export default __webpack_public_path__ + "static/media/cherished_memories_with.5c7715c6.pdf";